/* eslint-disable react/prop-types */ // TODO
import { setIsSummaryPanelVisible, setSelectedToolbarRoofSubTab } from '../../store/ui/uiSlice'

import ItemsAccordion from './ItemsAccordion/ItemsAccordion'

import * as Styled from './styles'
import { useAppSelector, useAppDispatch } from '../../hooks'
import * as DynamakerContract from '../../integration/DynamakerContract'

const formatValue = (value: number): string => `${(value / 1000).toFixed(1).toString().replace('.', ',')} m`

interface Props {
  tab: any
}

const Selections: React.FC<Props> = ({ tab }) => {
  const { content } = useAppSelector((state) => state.init) || {}
  const { erpItems, lfcItems } = useAppSelector((state) => state.items) || {}

  const {
    bom,
    meta: { buildingArea, roofType, roofCladding, snowZone, extraRoofHeight, roofAngle } = tab,
    props: { width, length, gutters, roofExtraHeight, loftLeft, loftRight, loftFloor, sillColor, garageDoorMotors, foundation },
  } = useAppSelector((state) => state.configResult)

  const dispatch = useAppDispatch()
  const items = (bom.find(section => section.type === 'ITEMS')?.articles ?? []) as DynamakerContract.ConfiguredArticleQty[]
  const doors = items.filter((item) => ['door', 'double-door'].includes(item.item))
  const doorsWithInfo = doors
    .map((door) => {
      const matchingLfcItems = lfcItems.find((item) => item.configuratorContextId === door.erpItemNumber)
      const matchingErpItems = erpItems.find((item) => item.Sku === door.erpItemNumber)
      if (matchingLfcItems || matchingErpItems) return { ...door, ...matchingLfcItems, ...matchingErpItems }
    }, [])
    .filter((item) => item !== undefined)

  const windows = items.filter((item) => ['window'].includes(item.item))
  const windowsWithInfo = windows
    .map((window) => {
      const matchingLfcItems = lfcItems.find((item) => item.configuratorContextId === window.erpItemNumber)
      if (matchingLfcItems) return { ...window, ...matchingLfcItems }
    }, [])
    .filter((item) => item !== undefined)

  const gates = items.filter((item) => ['garage-door', 'sliding-door', 'facade-section'].includes(item.item))
  const gatesWithInfo = gates
    .map((gate) => {
      const matchingLfcItems = lfcItems.find((item) => item.configuratorContextId === gate.erpItemNumber)
      const matchingErpItems = erpItems.find((item) => item.Sku === gate.erpItemNumber)
      if (matchingLfcItems || matchingErpItems) return { ...gate, ...matchingLfcItems, ...matchingErpItems }
    }, [])
    .filter((item) => item !== undefined)

  switch (tab) {
    case 'size':
      return (
        <Styled.Panel>
          <Styled.Attribute>
            <Styled.Label>{content.props.width.title}</Styled.Label>
            <Styled.Value>{formatValue(width.value)}</Styled.Value>

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>

          <Styled.Attribute>
            <Styled.Label>{content.props.length.title}</Styled.Label>
            <Styled.Value>{formatValue(length.value)}</Styled.Value>

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>

          <p>
            {content.meta.buildingArea.title}: <strong>{buildingArea.toString().replace('.', ',')} m²</strong>
          </p>
        </Styled.Panel>
      )
    case 'roof': {
      const isRoofExtraHeightDisabled = !roofExtraHeight.options.find((option: any) => option.value === true)?.available

      return (
        <Styled.Panel>
          <Styled.Attribute>
            <Styled.Label>{content.props.roofKind.title}</Styled.Label>

            {roofType === 'GABLE' && <Styled.Value>{content.props.roofKind.options.gable.title}</Styled.Value>}

            {roofType === 'PENT' && <Styled.Value>{content.props.roofKind.options.pent.title}</Styled.Value>}

            <Styled.ChangeButton
              onClick={() => {
                dispatch(setIsSummaryPanelVisible(false))
                dispatch(setSelectedToolbarRoofSubTab(0))
              }}
            >
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>

          <Styled.Attribute>
            <Styled.Label>{content.props.roofCladding.title}</Styled.Label>

            {roofCladding === 'NONE' && <Styled.Value>{content.props.roofCladding.options.none.title}</Styled.Value>}
            {roofCladding === 'TARPAPER' && <Styled.Value>{content.props.roofCladding.options['tar-paper'].title}</Styled.Value>}
            {roofCladding === 'SHEET_METAL_BLACK' && <Styled.Value>{content.props.roofCladding.options['sheet-metal-black'].title}</Styled.Value>}
            {roofCladding === 'SHEET_METAL_DARK_GREY' && <Styled.Value>{content.props.roofCladding.options['sheet-metal-dark-grey'].title}</Styled.Value>}
            {roofCladding === 'SHEET_METAL_SILVER_METALLIC' && <Styled.Value>{content.props.roofCladding.options['sheet-metal-silver-metallic'].title}</Styled.Value>}
            {roofCladding === 'SHEET_METAL_TERRACOTTA' && <Styled.Value>{content.props.roofCladding.options['sheet-metal-terracotta'].title}</Styled.Value>}

            <Styled.ChangeButton
              onClick={() => {
                dispatch(setIsSummaryPanelVisible(false))
                dispatch(setSelectedToolbarRoofSubTab(1))
              }}
            >
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>

          <Styled.Attribute>
            <Styled.Label>{content.props.snowZone.title}</Styled.Label>
            <Styled.Value>{snowZone}</Styled.Value>

            {!isRoofExtraHeightDisabled && (
              <Styled.ChangeButton
                onClick={() => {
                  dispatch(setIsSummaryPanelVisible(false))
                  dispatch(setSelectedToolbarRoofSubTab(2))
                }}
              >
                {content.summary_panel.configuration.change_button}
              </Styled.ChangeButton>
            )}
          </Styled.Attribute>

          {!!extraRoofHeight && (
            <Styled.Attribute>
              <Styled.Label>{content.props.roofExtraHeight.title}</Styled.Label>
            </Styled.Attribute>
          )}

          <span>
            {content.meta.roofAngle.title}: <strong>{roofAngle}°</strong>
          </span>
        </Styled.Panel>
      )
    }
    case 'loft':
      return (
        <Styled.Panel>
          <Styled.Attribute>
            <Styled.Label>{content.tabs[2].title}</Styled.Label>

            {loftLeft.value || loftRight.value ? (
              <Styled.Value>
                <span>
                  {loftLeft.value
                    ? `${content.props.loft.constructionPlan.positioning.left} ${loftLeft.value.toString().replace('.', ',')} m²`
                    : ''}
                </span>
                <span>
                  {loftRight.value
                    ? `${content.props.loft.constructionPlan.positioning.right} ${loftRight.value.toString().replace('.', ',')} m²`
                    : ''}
                </span>
                <span>{loftFloor.value === 'chip' ? content.props.loft.floor.options[1].title : ''}</span>
              </Styled.Value>
            ) : (
              <Styled.Value>{content.props.gutters.options.none.title}</Styled.Value>
            )}

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>
        </Styled.Panel>
      )
    case 'doors':
      return <ItemsAccordion itemsWithInfo={doorsWithInfo} itemType="door" />
    case 'windows':
      return <ItemsAccordion itemsWithInfo={windowsWithInfo} itemType="window" />
    case 'gates':
      return <ItemsAccordion itemsWithInfo={gatesWithInfo} itemType="gate" />
    case 'options':
      return (
        <Styled.Panel>
          <Styled.Attribute>
            <Styled.Label>{content.props.gutters.title}</Styled.Label>
            <Styled.Value>{content.props.gutters.options[gutters.value].title}</Styled.Value>

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>
          <Styled.Attribute>
            <Styled.Label>{content.props.foundation.title}</Styled.Label>
            <Styled.Value>{content.props.foundation.options[foundation.value].title}</Styled.Value>

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>
          <Styled.Attribute>
            <Styled.Label>{content.props.facadeSheetMetalColor.title}</Styled.Label>
            <Styled.Value>{content.props.facadeSheetMetalColor.options[sillColor.value].title}</Styled.Value>

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>
          <Styled.Attribute>
            <Styled.Label>{content.props.garageMotors.title}</Styled.Label>
            <Styled.Value>{`${garageDoorMotors.value} ${content.props.garageMotors.unit}`}</Styled.Value>

            <Styled.ChangeButton onClick={() => dispatch(setIsSummaryPanelVisible(false))}>
              {content.summary_panel.configuration.change_button}
            </Styled.ChangeButton>
          </Styled.Attribute>
        </Styled.Panel>
      )
    default:
      return null
  }
}

export default Selections
